import type { BundleApps as BundleAppsType } from '@wix/ambassador-devcenter-bundle-apps-v1-bundle-apps/types';

export class BundleApps {
  constructor(private readonly bundleApps: BundleAppsType | undefined) {}

  getApps() {
    return this.bundleApps?.bundleWebSolutions || [];
  }
}
